<template>
  <div class="role_group_cla">
    <zk-button-group
      :toolBar="true"
      :event="['addRole', 'addRoleGroup']"
      @addRole="addRoleDia"
      @addRoleGroup="RoleGroupDia"
    ></zk-button-group>

    <el-menu
      :default-active="defaultActive"
      @select="menuSelect"
      :unique-opened="true"
    >
      <el-submenu
        class="sub_menu_cla"
        v-for="item in roleTreeData"
        :index="item.id"
        :key="item.id"
        :name="item.id"
      >
        <template slot="title">
          <span>{{ item.name }}</span>
          <span v-if="item.editable">
            <i
              class="sub_menu_icon_cla role_icon_cla zk-icon-md-close"
              @click.stop="removeRoleGroupConfirm(item)"
            ></i>
          </span>
          <span v-if="item.editable" @click.stop="RoleGroupDia(item)">
            <i class="sub_menu_icon_cla role_icon_cla zk-icon-pencil"></i>
          </span>
        </template>
        <el-menu-item
          class="sub_menu_item_cla"
          v-for="menuItem in item.roleList"
          :index="menuItem.id"
          :key="menuItem.id"
          :name="menuItem.id"
        >
          <span>{{ menuItem.name }}</span>
          <span v-if="menuItem.editable">
            <i
              class="role_icon_cla zk-icon-md-close"
              @click.stop="deleteRoleConfirm(menuItem)"
            ></i>
          </span>
          <span v-if="menuItem.editable">
            <i
              class="role_icon_cla zk-icon-pencil"
              @click.stop="updateRole(menuItem)"
            ></i>
          </span>
        </el-menu-item>
      </el-submenu>
    </el-menu>

    <el-dialog
      :append-to-body="true"
      :title="$t('role.roleGroup')"
      :close-on-click-modal="false"
      :visible.sync="showRoleGroupDia"
      width="30%"
    >
      <el-form
        ref="formValidate"
        :model="roleGroupForm"
        label-width="170px"
        :rules="roleGroupValidate"
      >
        <el-form-item :label="$t('role.roleGroupName')" prop="name">
          <el-input
            v-model="roleGroupForm.name"
            :placeholder="$t('role.roleGroupNameRequire')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.stop="showRoleGroupDia = false">{{
          $t('common.cancel')
        }}</el-button>
        <el-button type="primary" @click.stop="addRoleGroup">{{
          $t('common.confirm')
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="$t('role.role')"
      :close-on-click-modal="false"
      :visible.sync="showRoleDia"
      width="30%"
    >
      <el-form
        ref="roleFormValidate"
        :model="roleForm"
        label-width="140px"
        :rules="roleFormValidate"
      >
        <el-form-item :label="$t('role.roleGroup')" prop="groupID">
          <el-select
            v-model="roleForm.groupID"
            :placeholder="$t('role.roleGroupRequire')"
          >
            <el-option
              :label="$t('role.noGroup')"
              value="nongrouping"
            ></el-option>
            <template v-for="item of roleTreeData">
              <el-option
                v-if="item.id !== 'nongrouping'"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('role.roleName')" prop="name">
          <el-input
            v-model="roleForm.name"
            :placeholder="$t('role.roleNameRequire')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.stop="showRoleDia = false">{{
          $t('common.cancel')
        }}</el-button>
        <el-button type="primary" @click.stop="saveRole">{{
          $t('common.confirm')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as roleService from '../../../services/role'
export default {
  name: 'ZkRoleGroup',
  data() {
    let roleGroupValidate = {
      name: [
        {
          required: true,
          message: this.$t('role.roleGroupNameRequire'),
          trigger: 'blur'
        }
      ]
    }
    let roleFormValidate = {
      name: [
        {
          required: true,
          message: this.$t('role.roleNameRequire'),
          trigger: 'blur'
        }
      ],
      groupID: [
        {
          required: true,
          message: this.$t('role.roleGroupRequire'),
          trigger: 'blur'
        }
      ]
    }
    let roleGroupForm = {
      name: '',
      groupID: ''
    }
    let roleForm = {
      name: '',
      id: '',
      groupID: 'nongrouping'
    }
    return {
      defaultActive: '',
      showRoleGroupDia: false,
      showRoleDia: false,
      roleGroupValidate,
      roleFormValidate,
      roleGroupForm,
      roleForm,
      isUpdate: false,
      roleTreeData: [],
      itemGroupName: ''
    }
  },
  methods: {
    menuSelect(roleId) {
      this.defaultActive = roleId
      this.$emit('menuSelect', roleId)
    },
    loadRoleTree() {
      roleService.queryRoleTree().then((data) => {
        this.roleTreeData = data.payload.results.roleTree
      })
    },
    RoleGroupDia(group) {
      if (group) {
        this.roleGroupForm.groupID = group.id
        this.roleGroupForm.name = group.name
        this.itemGroupName = group.name
      } else {
        this.roleGroupForm.groupID = ''
        this.roleGroupForm.name = ''
      }
      this.showRoleGroupDia = true
    },
    addRoleGroup() {
      // 角色组未修改
      if (this.itemGroupName === this.roleGroupForm.name) {
        this.showRoleGroupDia = false
        this.itemGroupName = ''
        return
      }
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          let params = {
            name: this.roleGroupForm.name,
            groupID: this.roleGroupForm.groupID
          }
          roleService
            .addRoleGroup(params)
            .then((data) => {
              if (data.code === '00000000') {
                this.showRoleGroupDia = false
                this.loadRoleTree()
              } else {
                this.$notify.error({
                  title: this.$t('common.errorNotice'),
                  message: data.message
                })
              }
            })
            .catch((data) => {
              this.$notify.error({
                title: this.$t('common.errorNotice'),
                message: data.message
              })
            })
        }
      })
    },
    removeRoleGroupConfirm(groupItem) {
      this.$confirm(
        this.$t('role.confirmDeleteGroupTip'),
        this.$t('common.warningNotice'),
        {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          let params = {
            groupID: groupItem.id
          }
          roleService
            .removeRoleGroup(params)
            .then((data) => {
              if (data.code === '00000000') {
                this.loadRoleTree()
              } else {
                this.$notify.error({
                  title: this.$t('common.errorNotice'),
                  message: data.message
                })
              }
            })
            .catch((data) => {
              this.$notify.error({
                title: this.$t('common.errorNotice'),
                message: data.message
              })
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelDelete')
          })
        })
    },
    addRoleDia() {
      this.roleForm = {}
      this.showRoleDia = true
      this.isUpdate = false
    },
    updateRole(roleItem) {
      this.showRoleDia = true
      this.isUpdate = true
      this.roleForm = JSON.parse(JSON.stringify(roleItem || {}))
    },
    saveRole() {
      let _self = this
      this.$refs.roleFormValidate.validate((valid) => {
        if (valid) {
          if (_self.isUpdate) {
            // 更新
            this.roleForm.editable = true
            roleService
              .update(this.roleForm)
              .then((data) => {
                if (data.code === '00000000') {
                  _self.showRoleDia = false
                  _self.loadRoleTree()
                  _self.$message.info(_self.$t('role.updateRoleSuccess'))
                } else {
                  _self.$notify.error({
                    title: this.$t('common.errorNotice'),
                    message: data.message
                  })
                }
              })
              .catch((data) => {
                _self.$notify.error({
                  title: this.$t('common.errorNotice'),
                  message: data
                })
              })
          } else {
            // 添加
            this.roleForm.editable = true
            roleService
              .add(this.roleForm)
              .then((data) => {
                if (data.code === '00000000') {
                  _self.showRoleDia = false
                  _self.$notify.info(_self.$t('role.updateRoleSuccess'))
                  _self.loadRoleTree()
                } else {
                  _self.$notify.error({
                    title: this.$t('common.errorNotice'),
                    message: data.message
                  })
                }
              })
              .catch((data) => {
                _self.$notify.error({
                  title: this.$t('common.errorNotice'),
                  message: data
                })
              })
          }
        }
      })
    },
    deleteRoleConfirm(roleItem) {
      let _this = this
      this.$confirm(
        this.$t('role.confirmDeleteTip'),
        this.$t('common.warningNotice'),
        {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          let params = {
            roleId: roleItem.id
          }
          roleService
            .removeRole(params)
            .then((data) => {
              if (data.code === '00000000') {
                _this.loadRoleTree()
                // this.queryRoleUser(roleItem.id)
                this.menuSelect('')
              } else {
                this.$notify.error({
                  title: this.$t('common.errorNotice'),
                  message: data.message
                })
              }
            })
            .catch((data) => {
              this.$notify.error({
                title: this.$t('common.errorNotice'),
                message: data
              })
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelDelete')
          })
        })
    }
  },
  computed: {
    roleBtns() {
      if (this.$root.activeMenu.children) {
        return this.$root.activeMenu.children.filter((item) => {
          return (
            item.resourceType === '3' &&
            (item.resourceEvent === 'addRole' ||
              item.resourceEvent === 'addRoleGroup')
          )
        })
      } else {
        return []
      }
    }
  },
  mounted() {
    this.loadRoleTree()
  }
}
</script>
<style lang="less" scoped>
.role_group_cla{
  min-height: calc(100vh - 200px);
  .el-select{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/roleGroup/src/main.vue